import { render } from "./SchedulePeriods.vue?vue&type=template&id=7bb988a9&scoped=true"
import script from "./SchedulePeriods.vue?vue&type=script&lang=js"
export * from "./SchedulePeriods.vue?vue&type=script&lang=js"

import "./SchedulePeriods.vue?vue&type=style&index=0&id=7bb988a9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb988a9"]])

export default __exports__